{
  "LOGO_ALT": "Book Me Now logo",
  "BOOK.SOMETHING_WENT_WRONG": " Sorry, something went wrong!",
  "BOOK.UNKNOWN_ERROR": " An unknown error occurred. Please try again.",
  "BOOK.SELECT_NEW_TIME": " Select new time ",
  "BOOK.TIME_SLOT_UNAVAILABLE": "Time slot unavailable",
  "BOOK.TIME_SLOT_UNAVAILABLE_DESCRIPTION": " The time slot you selected is no longer available. Please choose a new time to continue.",
  "BOOK.UNABLE_TO_LOCATE_MEETING": " We were unable to locate the requested meeting. ",
  "BOOK.PROBLEM_LOADING_MEETING": " There was a problem loading the requested meeting. ",
  "BOOK.HOST_NOT_FOUND": " Host not found",
  "BOOK.UNABLE_TO_DETERMINE_HOST": " We cannot determine who the host of the meeting is supposed to be. Please try again. ",
  "BOOK.EVENT_TYPE_NOT_FOUND": " EventType not found",
  "BOOK.MEETING_TYPE_NOT_FOUND": " Something went wrong while setting up the meeting. Please contact your Host.",
  "BOOK.RESCHEDULING_FAILED": " Rescheduling failed",
  "BOOK.RESCHEDULING_FAILED_DESCIPTION": " Couldn't reschedule the meeting. Try again later.",
  "BOOK.EVENT_TYPE_IS_DELETED": " EventType is deleted",
  "BOOK.MEETING_TYPE_NO_LONGER_EXISTS": " This meeting link is no longer available. Please contact your Host.",
  "BOOK.HOST_NOT_AVAILABLE": " Unable to book a meeting ",
  "BOOK.HOST_NOT_AVAILABLE_ERROR_MESSAGE": " We ran into an unexpected issue while scheduling your meeting/appointment and it has not been scheduled. Your host has been notified. ",
  "BOOK.EVENT_TYPE_IS_EXPIRED": " There are no available date/time slots",
  "BOOK.MEETING_TYPE_EXPIRED": "Please get in touch with host",
  "BOOK.EVENT_TYPE_ERROR": " Issue loading Event type",
  "BOOK.EVENT_TYPE_ERROR_DESCRIPTION": " Something went wrong while setting up the meeting. Please contact your Host.",
  "BOOK.CALENDAR_INVITE": "A calendar invite has been sent to your email address.",
  "BOOK.ERROR_OCCURRED": "An error occurred.",
  "BOOK.SMS_CONSENT_DISCLOSURE": "By providing your phone number, you agree to receive a booking confirmation and reminders via SMS.",
  "CALENDAR.SELECT_DATE_TIME": "Select a date and time",
  "CALENDAR.NO_TIMES_AVAILABLE": " There are no times available for these dates ",
  "CALENDAR.LOADING": "Loading...",
  "CALENDAR.ERROR_OCCURRED_LOADING_TIMES": " An error occurred loading the meeting times ",
  "CALENDAR.SELECT_DATE_TO_SHOW_TIMES": " Select a date to show times available ",
  "CALENDAR.SCHEDULE_A_MEETING": "Schedule a meeting",
  "CALENDAR.SCHEDULE_A_DEMO": "Schedule a demo",
  "CALENDAR.RESCHEDULE_A_MEETING": "Reschedule a meeting",
  "CALENDAR.MEETING_INFO.MINUTES": "minutes",
  "CANCEL.CANCEL_MEETING": "Cancel meeting",
  "CANCEL.ABOUT_TO_CANCEL": "You are about to cancel the following meeting",
  "CANCEL.REASON_FOR_CANCELLING": "Reason for cancelling (optional)",
  "CANCEL.RESCHEDULE_INSTEAD": "Reschedule instead",
  "CANCEL.PROBLEM_CANCELLING": "There was a problem canceling the meeting. Please try again later.",
  "CANCEL.MEETING_CANCELED": "Your meeting has been canceled",
  "CANCEL.MEETING_ALREADY_CANCELED": "This meeting has already been canceled",
  "CONFIRMATION.CONFIRMED": "Confirmed",
  "CONFIRMATION.RESCHEDULED": "Meeting rescheduled",
  "CONFIRMATION.CANCELED": "Meeting Canceled",
  "CONFIRMATION.YOU_ARE_SCHEDULED": "You are scheduled with {$INTERPOLATION}",
  "CONFIRMATION.WEB_CONFERENCE_DETAILS": "Web conference details will be emailed.",
  "CONFIRMATION.BETA_SIGN_UP": "Sign up for beta access and we’ll let you know when it’s ready!",
  "CONFIRMATION.SIGN_UP": "Sign up",
  "CONTACT_FORM.SCHEDULE_A_MEETING": "Schedule a meeting",
  "CONTACT_FORM.SCHEDULE_A_DEMO": "Schedule a demo",
  "CONTACT_FORM.TELL_US_MORE": "Tell us a bit more about yourself",
  "CONTACT_FORM.FIRST_NAME": "First Name",
  "CONTACT_FORM.LAST_NAME": "Last Name",
  "CONTACT_FORM.EMAIL": "Email",
  "CONTACT_FORM.EMAIL_ERROR": "Email is invalid",
  "CONTACT_FORM.INVITEE_EMAIL": "Additional guest email(s)",
  "CONTACT_FORM.PHONE_NUMBER": "Phone Number",
  "CONTACT_FORM.COMPANY_NAME": "Company Name",
  "CONTACT_FORM.WEBSITE": "Please provide your website",
  "CONTACT_FORM.LINKED_IN_URL": "Please provide your LinkedIn URL",
  "CONTACT_FORM.NUMBER_OF_EMPLOYEES": "How many Employees do you have?",
  "CONTACT_FORM.COMMENTS": "Comments",
  "CONTACT_FORM.SCHEDULE_MEETING_FOR_DATE_TIME": " Schedule meeting for {$INTERPOLATION} at {$INTERPOLATION_1} {$INTERPOLATION_2}",
  "CONTACT_FORM.PRIVACY_POLICY": "Privacy Policy",
  "CONTACT_FORM.TERMS_OF_SERVICE": "Terms of Service",
  "CONTACT_FORM.CHANGE_MEETING_TIME": " On second thought, I'd like to change the meeting time ",
  "LANDING_PAGE.MEETING_SCHEDULER_CALENDAR_ALT": "meeting scheduler calendar",
  "LANDING_PAGE.HASSLE_FREE_MEETING_SCHEDULING": "Provide hassle-free appointment scheduling to your customers",
  "LANDING_PAGE.SEAMLESSLY_CONNECTS": "Integrates perfectly with all types of businesses",
  "LANDING_PAGE.RETAIN_COMPLETE_CONTROL": "Retain complete control over your availability",
  "LANDING_PAGE.SET_GENERAL_HOURS": " Set your general hours and restrict specific times depending on your availability. Publicly displayed availability will stay in sync with your Google calendar in real time. ",
  "LANDING_PAGE.PERSONALIZE_DOMAIN": "Customize the booking experience to fit your unique needs",
  "LANDING_PAGE.RECEIVE_UNIQUE_LANDING_PAGE": "Create a unique and personalized scheduler by customizing meeting times, submission forms, and URLs that help make the experience memorable and that develops brand recognition.",
  "LANDING_PAGE.RECEIVE_EMAIL_ALERTS": "Receive email alerts when meetings are booked",
  "LANDING_PAGE.NO_NEED_TO_LOGIN": " There’s no need to login to check if a meeting has been scheduled. We’ll alert you via email, and automatically add the meeting to your Google Calendar. ",
  "LANDING_PAGE.HOW_DOES_IT_WORK": "How does it work?",
  "LANDING_PAGE.SHARE_PERSONALIZED_LINK": "Just share your personalized link with anyone",
  "LANDING_PAGE.PROVIDE_ACCESS_TO_BOOKING_PAGE": "Whether it’s a link in an email or a button on your website, providing access to you unique booking page is easy. Once visitors arrive, there’s a simple two-step process to book a meeting with you. ",
  "LANDING_PAGE.CONFIRM_MEETING_TIME_ALT": "confirm meeting time",
  "RESCHEDULE.MEETING_RESCHEDULED": "Your meeting has been rescheduled",
  "RESCHEDULE.CONFIRM_NEW_APPOINTMENT": "Confirm new appointment",
  "RESCHEDULE.CONFIRM_DESCRIPTION": "Please confirm the changes to your appointment time and proceed to confirmation.",
  "RESCHEDULE.UPDATED_DATE_TIME": "Updated date & time",
  "RESCHEDULE.MEETING_LINK_CALENDAR_UPDATED_AUTO": "Meeting link and calendar invite will be updated automatically.",
  "RESCHEDULE.CHOOSE_ANOTHER_TIME": "Choose another time",
  "RESCHEDULE.CONFIRM_CHANGES": "Confirm changes",
  "RESCHEDULE.APPOINTMENT_RESCHEDULED": "Appointment rescheduled!",
  "RESCHEDULE.SUCCESS_DESCRIPTION": "Your event has been successfully rescheduled",
  "RESCHEDULE.MEETING_LINK_CALENDAR_UPDATED_SHORTLY": "Meeting link and calendar invite will be updated shortly.",
  "MEETING_TYPE_SELECTION.TITLE": "Select from the options below to add an event to my calendar",
  "GROUP_TYPE_SELECTION.TITLE": "Select event types from  the options below",
  "MEETING_TYPE_SELECTION.DURATION": "minutes",
  "SERVICE_SELECTION.TITLE": "Select group and event types from the options below",
  "GROUP_SERVICE.ERROR": "There seems to be an issue with the URL. Please contact the administrator for assistance.",
  "MEETING_ACTION.DIALOG.TEAM_MEMBER.ANY": "--- Any ---",
  "SESSION.ERROR_BOOKING": "Session Booking Error",
  "SESSION.ERROR_BOOKING_DESCRIPTION": "There was an error booking this session. Please try again or contact support.",
  "SESSION.NOT_FOUND": "Session Not Found",
  "SESSION.NOT_FOUND_DESCRIPTION": "The session you're looking for could not be found. Please check the URL or contact the host.",
  "SESSION.EXPIRED": "You can no longer register for this session",
  "SESSION.EXPIRED_DESCRIPTION": "Registrations are closed. Your information has been recorded, you will receive confirmation if we are able to accommodate you.",
  "SESSION.MAX_ATTENDEE_COUNT": "No seats available for this session",
  "SESSION.MAX_ATTENDEE_COUNT_DESCRIPTION": "Sorry, there are no more seats available. We have recorded your interest, you will receive confirmation if we are able to accommodate you.",
  "SESSION.DELETED": "Session is Deleted",
  "SESSION.DELETED_DESCRIPTION": "This session link is no longer available. Please contact your Host.",
  "SESSION.ERROR": "Session Error",
  "SESSION.ERROR_DESCRIPTION": "There was an error with this session. Please try again later or contact support.",
  "SESSION.ALREADY_BOOKED": "You have already booked for the session",
  "SESSION.ALREADY_BOOKED_DESCRIPTION": "The email id or phone number passed has already been registered for the session.",
  "SESSION.BOOKED": "Successfully booked",
  "SESSION.BOOKED_DESCRIPTION": "You have successfully registered for the session.",
  "SESSION.CANCELLED": "Successfully Cancelled",
  "SESSION.CANCELLED_DESCRIPTION": "You have successfully de-registered for the session.",
  "SESSION.CANNOT_CANCEL_MEETING_STARTED": "Cannot Cancel Session",
  "SESSION.CANNOT_CANCEL_MEETING_STARTED_DESCRIPTION": "You cannot cancel this session as the meeting has already started.",
  "SESSION.ALREADY_CANCELLED": "Session already cancelled",
  "SESSION.ALREADY_CANCELLED_DESCRIPTION": "The session has already been cancelled.",
  "SESSION.NOT_ACTIVE": "Session not active",
  "SESSION.NOT_ACTIVE_DESCRIPTION": "The session event has been cancelled by the host.",
  "SESSION.UNKNOWN_ERROR": "Something went wrong!",
  "SESSION.UNKNOWN_ERROR_DESCRIPTION": "An unknown error occurred. Please try again or contact support.",
  "MEETING_INFO.ALL_SET_TITLE": "Appointment scheduled!",
  "MEETING_INFO.ALL_SET_DESCRIPTION": "Your event has been successfully scheduled",
  "MEETING_INFO.REDIRECTING": "Redirecting in {$INTERPOLATION} seconds...",
  "MEETING_INFO.NEED_HELP_JOINING": "Need help joining?",
  "MEETING_INFO.NEED_TO_MAKE_CHANGES": "Need to make changes ?",
  "MEETING_INFO.MEETING_DETAILS_EMAILED_SHORTLY": "Meeting details will be emailed shortly",
  "MEETING_INFO.MEETING_DETAILS_MESSAGED_SHORTLY": "Meeting details will be messaged shortly",
  "MEETING_INFO.CALENDAR_LINK_EMAILED_SHORTLY": "Calendar link will be emailed shortly",
  "MEETING_INFO.CALENDAR_LINK_MESSAGED_SHORTLY": "Calendar link will be messaged shortly",
  "CANCEL_INFO.TITLE": "Cancel appointment?",
  "CANCEL_INFO.SUBTITLE": "Please confirm if you want to cancel your appointment.",
  "CANCEL_INFO.DETAILS": "Details",
  "CANCEL_INFO.WHEN": "When",
  "CANCEL_INFO.WHERE": "Where",
  "CANCEL_INFO.REASON": "Cancellation details",
  "CANCEL_INFO.REASON_PLACEHOLDER": "Please enter a reason for cancellation.",
  "CANCEL_INFO.ONLINE_APPOINTMENT": "Online appointment",
  "CANCEL_INFO.INFO_BANNER": "Meeting link and calendar invite will be updated automatically",
  "CANCEL_INFO.RESCHEDULE_INSTEAD": "Reschedule instead",
  "CANCEL_INFO.CANCEL_BUTTON": "Cancel appointment",
  "CANCEL_INFO.OPTIONAL": "optional",
  "CANCELLED_INFO.TITLE": "Appointment cancelled!",
  "CANCELLED_INFO.SUBTITLE": "Your event has been cancelled",
  "CANCELLED_INFO.NEED_TO_BOOK": "Need to book an appointment ?",
  "CANCELLED_INFO.BOOK_NOW": "Book now",
  "SHARED_MEETING.NOT_FOUND": "Video not found",
  "SHARED_MEETING.NOT_FOUND_DESCRIPTION": "This video doesn't exist or is no longer available.",
  "SHARED_MEETING.ERROR": "Something went wrong",
  "SHARED_MEETING.ERROR_DESCRIPTION": "Unable to load the video. Please try again later.",
  "SHARED_MEETING.ARIA_LABEL": "Meeting recording",
  "SHARED_MEETING.VIDEO_BROWSER_NOT_SUPPORTED": "Your browser does not support the video tag.",
  "VALIDATION.REQUIRED": "This field is required",
  "VALIDATION.EMAIL_INVALID": "Email is invalid",
  "VALIDATION.SELECT_AN_OPTION": "Select an option",
  "BOOK.CUSTOMER_INFO.TITLE": "Customer information",
  "BOOK.CUSTOMER_INFO.SUBTITLE": "Provide all mandatory fields",
  "BOOK.CUSTOMER_INFO.FIRST_NAME": "First name",
  "BOOK.CUSTOMER_INFO.LAST_NAME": "Last name",
  "BOOK.CUSTOMER_INFO.EMAIL_ADDRESS": "Email address",
  "BOOK.CUSTOMER_INFO.ADD_ADDITIONAL_GUESTS": "+ Add additional guests",
  "BOOK.CUSTOMER_INFO.ENTER_EMAIL": "Enter email",
  "BOOK.CUSTOMER_INFO.ENTER_ADDITIONAL_GUESTS_HELPER": "Enter additional guests email id here",
  "BOOK.CUSTOMER_INFO.PHONE_NUMBER": "Phone number",
  "BOOK.CUSTOMER_INFO.LOCATION": "Location",
  "BOOK.CUSTOMER_INFO.LOCATION_PLACEHOLDER": "Add your location",
  "BOOK.CUSTOMER_INFO.LOCATION_GUIDELINES": "Location Guidelines:",
  "BOOK.CUSTOMER_INFO.ADDITIONAL_COMMENTS": "Additional comments",
  "BOOK.CUSTOMER_INFO.ADDITIONAL_COMMENTS_PLACEHOLDER": "Any special requests or notes for your appointment...",
  "BOOK.CUSTOMER_INFO.GUEST_EMAIL_LIST_ARIA_LABEL": "Guest email list",
  "BOOK.CUSTOMER_INFO.REMOVE_EMAIL_ARIA_LABEL": "Remove email",
  "BOOK.CUSTOMER_INFO.CLEAR_ALL_AND_CLOSE_ARIA_LABEL": "Clear all and close",
  "BOOK.SCHEDULE_APPOINTMENT": "Schedule appointment",
  "BOOK.BOOK": "Book",
  "BOOK.BACK": "Back",
  "BOOK.SUMMARY": "Summary",
  "BOOK.RESCHEDULE": "Reschedule",
  "BOOK.ENTER_DETAILS": "Enter details",
  "PROVIDER_SELECTION.TITLE": "Choose a service provider",
  "PROVIDER_SELECTION.PROVIDER_ASSIGNED_TITLE": "Provider already assigned",
  "PROVIDER_SELECTION.PROVIDER_ASSIGNED_MESSAGE": "The services in your booking already have a provider assigned. Continue to pick a date and time.",
  "PROVIDER_SELECTION.SHOW_PROVIDER_FOR_ALL_SERVICES": "Show provider for all services",
  "PROVIDER_SELECTION.CHOOSE_PROVIDER_PER_SERVICE": "Choose provider per service",
  "PROVIDER_SELECTION.ANY_AVAILABLE": "Any available",
  "PROVIDER_SELECTION.BASED_ON_AVAILABILITY": "Based on availability",
  "PROVIDER_SELECTION.NO_SERVICES_SELECTED": "No services selected. Go back to add services.",
  "PROVIDER_SELECTION.CHOOSE_DATE_AND_TIME": "Choose date and time",
  "PROVIDER_SELECTION.SELECT_PROVIDER_FOR_ALL_ARIA_LABEL": "Select a provider for all services",
  "PROVIDER_SELECTION.SELECT_PROVIDER_FOR_SERVICE_ARIA_LABEL": "Select a provider for {{serviceName}}",
  "SCHEDULING.SEARCH_SERVICES_PLACEHOLDER": "Search services...",
  "SCHEDULING.NO_SERVICES_FOUND_MATCHING": "No services found matching \"{{searchQuery}}\"",
  "SCHEDULING.NO_SERVICES_AVAILABLE": "No services available at this time.",
  "SCHEDULING.ADDITIONAL_SERVICES": "Additional services",
  "SCHEDULING.SELECT_ONE": "Select one",
  "SCHEDULING.OPEN_SEARCH": "Search services",
  "SCHEDULING.CLOSE_SEARCH": "Close search",
  "SCHEDULING.MAX_SERVICES_WARNING": "Max of 5 services can be selected",
  "SCHEDULING.CURRENTLY_UNAVAILABLE": "Currently unavailable",
  "BOOKING_CART.EMPTY_STATE": "Choose a service to plan your appointment",
  "BOOKING_CART.NEED_TO_MAKE_CHANGES": "Need to make changes?",
  "BOOKING_CART.TOTAL_DURATION": "TOTAL DURATION",
  "BOOKING_CART.REMOVE_ITEM_ARIA_LABEL": "Remove item",
  "BOOKING_CART.SERVICE_COUNT_ONE": "{{count}} service",
  "BOOKING_CART.SERVICE_COUNT_MANY": "{{count}} services",
  "BOOKING_CART.CHOOSE_PROVIDER": "Choose provider",
  "BOOKING_CART.YOUR_SELECTION": "Your selection",
  "CALENDAR.SEARCH_TIMEZONE_PLACEHOLDER": "Search timezone...",
  "CALENDAR.PREVIOUS_MONTH_ARIA_LABEL": "Previous month",
  "CALENDAR.NEXT_MONTH_ARIA_LABEL": "Next month",
  "CALENDAR.PREVIOUS_WEEK_ARIA_LABEL": "Previous week",
  "CALENDAR.NEXT_WEEK_ARIA_LABEL": "Next week",
  "CONTACT_FORM.ADDITIONAL_EMAIL_LIST_ARIA_LABEL": "Additional email list",
  "CONTACT_FORM.REMOVE_EMAIL_ARIA_LABEL": "Remove email",
  "BOOK.SUBMISSION_ERROR": "Something went wrong while submitting your booking. Please try again.",
  "BOOK.UNEXPECTED_ERROR": "An unexpected error occurred. Please try again later.",
  "CANCEL.MEETINGS_CANCELED": "Your meetings have been canceled",
  "RESCHEDULE.MEETINGS_RESCHEDULED": "Your meetings have been rescheduled",
  "SESSION.REGISTRATION_SUCCESS": "You have been successfully registered for this session.",
  "SESSION_CANCEL.CANCELLATION_SUCCESS": "You have successfully cancelled your session registration.",
  "SESSION_CANCEL.CANCEL_SESSION": "Cancel session",
  "SESSION_CANCEL.ABOUT_TO_CANCEL": "You are about to cancel the following session",
  "SESSION_CANCEL.REASON_FOR_CANCELLING": "Reason for cancelling (optional)",
  "SHARED_MEETING.AUDIO_BROWSER_NOT_SUPPORTED": "Your browser does not support the audio tag.",
  "MEETING.ALREADY_CANCELLED": "Meeting already cancelled",
  "MEETING.ALREADY_CANCELLED_DESCRIPTION": "This meeting has already been cancelled.",
  "MEETING.NOT_FOUND": "Meeting not found",
  "MEETING.NOT_FOUND_DESCRIPTION": "The meeting you're looking for could not be found. Please check the URL or contact the host.",
  "MEETING.ERROR": "Something went wrong",
  "MEETING.ERROR_DESCRIPTION": "There was an error with this meeting. Please try again later or contact support.",
  "MEETING.CANCELLED_CANNOT_RESCHEDULE": "Meeting has been cancelled",
  "MEETING.CANCELLED_CANNOT_RESCHEDULE_DESCRIPTION": "This meeting has been cancelled and can no longer be rescheduled.",
  "MEETING.RESCHEDULE_NOT_FOUND": "Meeting not found",
  "MEETING.RESCHEDULE_NOT_FOUND_DESCRIPTION": "The meeting you're trying to reschedule could not be found. Please check the URL or contact the host.",
  "MEETING.RESCHEDULE_ERROR": "Rescheduling failed",
  "MEETING.RESCHEDULE_ERROR_DESCRIPTION": "There was an error rescheduling this meeting. Please try again later or contact support.",
  "CONTACT_FORM.LOCATION": "Location",
  "CALENDAR.AVAILABLE_TIMES": "Available times",
  "CALENDAR.TRY_AGAIN": "Try again",
  "CALENDAR.FILTER_ALL": "All",
  "CALENDAR.FILTER_MORNING": "Morning",
  "CALENDAR.FILTER_AFTERNOON": "Afternoon",
  "CALENDAR.FILTER_EVENING": "Evening",
  "BOOKING_STEPS.SERVICES": "Services",
  "BOOKING_STEPS.PROVIDER": "Provider",
  "BOOKING_STEPS.DATE_TIME": "Date & time",
  "BOOKING_STEPS.CONFIRM": "Confirm",
  "BOOK.PAGE_TITLE": "Book Your Appointment",
  "RESCHEDULE.PAGE_TITLE": "Reschedule Appointment",
  "BOOKING_CART.CHOOSE_DATE_TIME": "Choose date & time",
  "CALENDAR.NO_TIMESLOTS_FOR_DATES": "There are no time slots available for these dates",
  "CALENDAR.NO_TIMESLOTS_FOR_DATE": "No timeslots available for the selected date",
  "CALENDAR.NO_MATCHING_TIMEZONES": "No matching timezones",
  "CALENDAR.SELECT_DATE_TO_SEE_TIMES": "Select a date to see available times",
  "MEETING_INFO.GET_DIRECTIONS": "Get Directions",
  "MEETING_INFO.MEETING_LINK": "Meeting Link",
  "MEETING_INFO.IN_PERSON_APPOINTMENT": "This is an in-person appointment",
  "MEETING_INFO.IN_PERSON_APPOINTMENT_SHORT": "In-person appointment",
  "MEETING_INFO.ADD_TO_CALENDAR": "Add to calendar",
  "MEETING_INFO.GOOGLE": "Google",
  "MEETING_INFO.OUTLOOK": "Outlook",
  "MEETING_INFO.OR": "or",
  "CANCEL_INFO.CANCEL": "Cancel",
  "RESCHEDULE.RESCHEDULE_MEETING_BUTTON": "Reschedule meeting",
  "SHARED.PHONE_INPUT.CODE": "Code",
  "SHARED.PHONE_INPUT.SEARCH_COUNTRY_PLACEHOLDER": "Search country...",
  "SHARED.PHONE_INPUT.NO_COUNTRIES_FOUND": "No countries found",
  "SHARED.PHONE_INPUT.INVALID_PHONE_NUMBER": "Please enter a valid phone number",
  "CONFIRMATION.MEETING_INVITATION_UPDATED_SHORTLY": "You will receive the updated meeting invitation shortly.",
  "CONTACT_FORM.EMAIL_ALREADY_IN_GUEST_LIST": "This email is already present in the additional guest list"
}
